import { Loading } from "components/Loading/loading";
import Carousel from "react-bootstrap/Carousel";

import { useContext, useEffect, useRef, useState } from "react";
import { getGalleryBoard, getDownloadUrlAttachmentAsync } from "./api";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import "./style.scss";
import a from "./ax-neveshteh-donya-1400-01.jpg";
import { Widget } from "components/Widget/Widget";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GUID_EMPTY } from "utils/constants";

export const GalleryWidget = ({ Board, handleGalleryResponse,boardResponse }) => {
  const [pages, setPages] = useState(1);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(2);
  const [loading, setLoading] = useState(true);
  const [attachIdList, setAttachIdList] = useState([]);
  const [time, setTime] = useState<boolean>(false);
  const [totalRecords,setTotalRecords]=useState<any>(0)

  const layoutContext = useContext(LayoutContext);

  const [response, setResponse] = useState<any>([]);

  const handleSelect = (selectedIndex) => {
     setTime((prev)=>!prev)

    if (selectedIndex?.target?.className?.includes("next")) {
      if (pageNum > 1) {
        setPageNum(pageNum - 1);
      } else {
        setPageNum(pages);
      }
    } else if (selectedIndex.target.className.includes("prev")) {
      if (pageNum < pages) {
        setPageNum(pageNum + 1);
      } else {
        setPageNum(1);
      }
    } else {
      if (selectedIndex.target.getAttribute("aria-label")?.includes("Slide")) {
        setPageNum(
          +selectedIndex.target.getAttribute("aria-label").replace("Slide ", "")
        );
      }
    }
    return false;
  };

  function getWidth() {
    if(document
      .querySelector(".innerWidget")){
 if (!layoutContext.sidebarIsOpen) {
      let innerWidget = document
        .querySelector(".innerWidget")
        ?.getBoundingClientRect() as any;
      setPageSize(
        Math.floor((innerWidget?.width-60) / 380) != 0
          ? Math.floor((innerWidget?.width-60) / 380)
          : 1
      );
    } else {
      let innerWidget = document
        .querySelector(".innerWidget")
        ?.getBoundingClientRect() as any;
      setPageSize(
        Math.floor((innerWidget?.width-60) / 380) != 0
          ? Math.floor((innerWidget?.width-60) / 380)
          : 1
      );
    }
    let innerWidget = document
      .querySelector(".innerWidget")
      ?.getBoundingClientRect() as any;

    return Math.floor((innerWidget?.width-60) / 380) != 0
      ? Math.floor((innerWidget?.width-60) / 380)
      : 1;
      }
      else{
             setPageSize(1);
             return 1
      }
  }
  const getGalleryBoardAsync = async (
    pageSi = pageSize,
    pageNumProp = pageNum,
  ) => {
    setLoading(false);
    try {
      if((totalRecords==response?.length && response?.length>0) ||( response?.length==1 && response[0]?.Id==GUID_EMPTY) ){ 
        setPages(
          response?.length > pageSi
          ? Math.ceil(response?.length / pageSi)
          : 1
        );
        
        handleGalleryResponse(response);
        
        setTime((prev)=>!prev)

      }else{ 
      const res = await getGalleryBoard(
        pageSi==-1?1:pageSi,//درصورتی -1 میشود که کاربر تازه وارد صفحه شده و هنوز درخواست نزده که لیست بگیره پس چون شرط طول ریسپانس داریم برای نمایش پس ویجت گالری دیده نمیشه  در نهایت نمیتونه سایز و تشخیص بده و -1 میزاره
        pageNumProp,
        window.innerWidth < 450 ? 250 : 380
      );
      setPages(
        res.Data.TotalRecords > pageSi
          ? Math.ceil(res.Data.TotalRecords / pageSi)
          : 1
      );
let newArry=new Set()
let result=[] as any
[...response, ...res.Data.Data].map(item => {
  if (!newArry.has(item.Id)) {
    newArry.add(item.Id);
    result.push(item);
  }
});
      setResponse(result);
      setAttachIdList(res.Data.Data.map((item) => item.Id));
      handleGalleryResponse(res.Data.Data);
setTotalRecords(res.Data.TotalRecords)
      setTime((prev)=>!prev)
}} catch (error) {}
    setLoading(true);
  };



  window.onresize = () => {
    getWidth();
  };

  useEffect(() => {
    getWidth();
  }, [layoutContext.sidebarIsOpen]);
  useEffect(() => {
    const sizing=getWidth()
    getGalleryBoardAsync(sizing);
  }, [pageNum,Board,layoutContext.sidebarIsOpen,window.innerWidth,
        // JSON.parse(localStorage.getItem('widgetList') as any)?.Board
        document.querySelector(".innerWidget")?.clientWidth,//برای وقتی یک دونه برد داشتیم و ابعاد 3 و 9 بوده حالا تعداد شده دوتا و ابعاد 6 و 6 میشه پس باید درخواست بزنه
         layoutContext?.widgetFormFlag,
         layoutContext?.currentUserPosition?.OrganizationType,
      ]);

  const getImageByAttachId = async (id) => {
    try{
    const list =  await getDownloadUrlAttachmentAsync(id );
                    const blob = new Blob([list])
                
               
                    
             
      
      setResponse((prev) =>
        prev.map((item) => (item.Id == id ? { ...item, Img: URL.createObjectURL(blob) } : item))
      );
    } catch {}
  };

  useEffect(() => {
    const intervalRequest = setInterval(() => {
//اگر شماره پیج 1 باشد و کلا یک اسلاید داشته باشیم نباید پیج نامبر زیاد کنیم و باید همون 1 بمونه
      if ((pageNum == 1 && totalRecords>1) || pageNum < pages) {
        setPageNum((prev) => prev + 1);
      } else {
        setPageNum((prev) => 1);
      }
    }, 7000);

    return () => {
      clearInterval(intervalRequest);
    };
  }, [time]);


  useEffect(() => {
    if (attachIdList?.length) {
     
      attachIdList.forEach((item) =>{
        if(item!=GUID_EMPTY){
getImageByAttachId(item)
        }
      } );
    }
  }, [attachIdList, attachIdList.length]);

  return (
    <>
    {response?.[0]?.Id==GUID_EMPTY ?<></>:
       <div
        className={` ${(!Board ||  boardResponse?.Data?.[0]?.Id==GUID_EMPTY ) && response?.[0]?.Id!=GUID_EMPTY && !!response.length?'col-md-12 ps-md-auto  ':boardResponse?.TotalRecords>1 ?layoutContext.sidebarIsOpen?'col-xl-6 col-md-8':'col-md-8 col-lg-6':response?.[0]?.Id==GUID_EMPTY || !response?.length?'d-none':'col-md-8'}    col-12 ps-4 mb-4 mb-md-0  `}
        style={{ height: "240px", maxHeight: "240px", minHeight: "240px" }}
      >
        <Widget
          title="Gallery"
          fullScreen={true}
          icon={["fas", "object-group"]}
          color="primary"
          id={"GalleryBoard"}
        >
          {!!response.length ? (
            <div style={{ margin: "6px 0px 8px 0px", height: "91.5%" }}>
              <Carousel
                fade
                nextLabel
                variant={"dark"}
                activeIndex={0}
                indicators={false}
                onClick={handleSelect}
                className=" gallery w-100  "
                style={{ height: "100%" }}
              >
                <Carousel.Item className="h-100">
                  <div className={`d-flex justify-content-evenly h-100  `}>
                    {loading ? (
                      response?.map((i, index) => (
                  (     index<pageSize*pageNum && index>= pageSize*(pageNum-1) ) &&
                        <div
                          className={`h-100 align-items-center d-flex justify-content-center`}
                          style={{ maxWidth: "410px", width: "100%" }}
                        >
                          {  i?.Img?

                          <div
                            className="d-flex h-100  align-items-center justify-content-center"
                            style={{
                              width: "100%",
                              height: "inherit",
                              float: "left",
                              marginRight: "5px",
                            }}
                          >
                            {/* <img
                              src={a}
                              alt=""
                              style={{
                                maxWidth: "400px",
                                aspectRatio: "2/1",
                                height:
                                  window.innerWidth < 450 ? "125px" : "100%",
                                maxHeight:
                                  window.innerWidth < 450 ? "125px" : "100%",
                                minHeight:
                                  window.innerWidth < 450 ? "125px" : "100%",
                              }}
                            /> */}

                             <img src={i.Img} alt=""  style={{
                                maxWidth: "380px",
                                aspectRatio: "2/1",
                            width:'380px',
                      
                                height:
                                  window.innerWidth < 450 ? "125px" : "190px",
                                maxHeight:
                                  window.innerWidth < 450 ? "125px" : "190px",
                                minHeight:
                                  window.innerWidth < 450 ? "125px" : "190px",
                              }} />  
                          </div>
                          :
                          <FontAwesomeIcon icon={'file-circle-exclamation'}  style={{color:'#e2e8f0'
                                  }}  className="ms-md-4 mt-md-3 card-icon "/>
}
                        </div>
                      ))
                    ) : (
                      <div className="col">
                        <Loading />
                      </div>
                    )}
                  </div>
                </Carousel.Item>
              </Carousel>
            </div>
          ) : (
            <></>
          )}
        </Widget>
      </div>}
   
    </>
  );
};
